import Bugsnag from "@bugsnag/js";
import BugsnagPluginReact from "@bugsnag/plugin-react";
import { User } from "../../lib/auth";
import { envConfig } from "../../config";

/**
 * Initializes the Bugsnag client.
 * Expected to be called during app startup.
 *
 * https://docs.bugsnag.com/platforms/javascript/react/#basic-configuration
 */
export const initializeBugsnag = () =>
  Bugsnag.start({
    apiKey: envConfig.bugsnagApiKey || "",
    plugins: [new BugsnagPluginReact()],
    appVersion: envConfig.appVersion,
    releaseStage: envConfig.bugsnagReleaseStage,
    enabledReleaseStages: ["production", "qa"],
  });

/**
 * Set the Bugsnag user id for the current Bugsnag session.
 */
export const setBugsnagUser = (userResponse: User) => {
  Bugsnag.setUser(userResponse.userId.toString());
  addBugsnagMetaData("user", {
    accountId: userResponse.accountRefid.toString(),
    isImpersonated: userResponse.isImpersonated.toString(),
  });
};

/**
 * Clear the Bugsnag user id for the current session.
 */
export const clearBugsnagUser = () => Bugsnag.setUser(undefined);

/**
 * Add custom metadata to global bugsnag reporting
 * @param name Metadata Name
 * @param parameters Metadata Parameters to track
 */
const addBugsnagMetaData = (
  name: string,
  parameters: Record<string, string>,
) => {
  Bugsnag.addMetadata(name, parameters);
};
